import { createContext } from "react";

export const MessagingContext = createContext()
export const VisitContext = createContext()